import React from "react";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Label } from "../../../designSystem/Label";
import { toDateString } from "../../../utils/date";
import { Select } from "../../../designSystem/inputs/Select";


type ArticleVersionHeaderProps = {
    version: number,
    releasedDate: Date,
    versions:number[],
    onVersionChange: (version: number) => void,
};
export function ArticleVersionHeader (props: ArticleVersionHeaderProps)
{
    return (
        <Flex justifyContent='space-between' alignItems='center'>
            <Flex flexDirection="column" gap={4}>
                <div>
                    <Label>Version {props.version}</Label>
                </div>

                <span>Opdateret d. {toDateString(props.releasedDate as Date)}</span>
            </Flex>

            <div>
                {props.versions.length > 1 && props.version &&
                    <div style={{width:'200px'}}>
                    <Select 
                        options={props.versions.map(v => ({ text: `Version ${v}`, value: v.toString() }))}
                        selectedValue={props.version.toString()}
                        onChange={(newValue) => props.onVersionChange(Number(newValue))}
                    />
                    </div>
                }
            </div>
        </Flex>
    );
}